import { cn } from '@sandtech-hub-monorepo/ui-kit';

import { ModuleAccess } from '../../data/programs';

/**
 * Figma 12150:55350: Free on a blue ground, Partially Free on a lighter one,
 * Paid in the darker saffron. `--saffron-active` already holds that exact
 * brown, so none of this needs a literal colour.
 */
const CHIP: Record<ModuleAccess, { label: string; className: string }> = {
  free: { label: 'Free', className: 'bg-primary/15 text-primary' },
  'partially-free': {
    label: 'Partially Free',
    className: 'bg-primary/5 text-primary',
  },
  paid: {
    label: 'Paid',
    className: 'bg-saffron-active/10 text-saffron-active',
  },
};

interface Props {
  access: ModuleAccess;
}

/**
 * What a subscription would add, stated on one row of the curriculum.
 *
 * Rendered by the informative `ModuleRow`, which is where `partially-free` is
 * measured rather than summarised: a module is one Savanna block, and a block
 * is the group that can straddle the paywall.
 *
 * Callers decide whether to render it at all. Once a subscription covers the
 * program the labels describe nothing, so the rows drop them.
 */
export const AccessChip = ({ access }: Props) => (
  <span
    className={cn(
      'shrink-0 rounded-full px-2.5 py-0.5 text-xs font-medium',
      CHIP[access].className
    )}
  >
    {CHIP[access].label}
  </span>
);
